import * as React from 'react';

const BredcrumbsIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='5'
    height='8'
    viewBox='0 0 5 8'
    fill='none'
  >
    <path
      d='M0.749675 7.58268C0.638563 7.58268 0.541341 7.54449 0.458008 7.4681C0.374674 7.39171 0.333008 7.29102 0.333008 7.16602V0.832682C0.333008 0.707682 0.374674 0.606988 0.458008 0.530599C0.541341 0.45421 0.638563 0.416016 0.749675 0.416016C0.777452 0.416016 0.874674 0.457682 1.04134 0.541016L4.06217 3.56185C4.13162 3.63129 4.18023 3.70074 4.20801 3.77018C4.23579 3.83963 4.24967 3.91602 4.24967 3.99935C4.24967 4.08268 4.23579 4.15907 4.20801 4.22852C4.18023 4.29796 4.13162 4.3674 4.06217 4.43685L1.04134 7.45768C0.999675 7.49935 0.954536 7.5306 0.905924 7.55143C0.857313 7.57227 0.80523 7.58268 0.749675 7.58268Z'
      fill='#ACA6A6'
    />
  </svg>
);

export default BredcrumbsIcon;
